// extracted by mini-css-extract-plugin
export default {"icon":"App_icon__23l3m","skipLink":"App_skipLink__ccyA2","container":"App_container__vKrbQ","marquee":"App_marquee__D3i4+"};